import React from 'react';
import uniqueId from 'lodash/uniqueId';
import cn from 'classnames';
import './FormField.scss';

type Props = {
  /** Различные поля формы */
  children: React.ReactNode;

  /** Идентификатор */
  id?: string;

  /** Текст Label */
  caption: string;

  /** Обязательное поле */
  isRequired?: boolean;

  /** Сообщение об ошибке */
  error?: string;

  /** Комментарий */
  comment?: string;

  /** Дополнительный класс */
  className?: string;
};

const uniqId = uniqueId();

const FormField: React.FC<Props> = (props) => {
  const { children, id, caption, isRequired, error, comment, className, ...attr } = props;

  const newChildren = React.cloneElement(children as React.ReactElement<any>, {
    id: id || `form-field-${uniqId}`,
  });

  return (
    <div className={cn('form-field', className)} {...attr}>
      <label className="form-field__caption" htmlFor={id || `form-field-${uniqId}`}>
        {caption}
        {isRequired && (
          <abbr className="form-field__required-symbol" title="Обязательное поле">
            *
          </abbr>
        )}
      </label>
      <div className="form-field__content">
        <div className="form-field__control">{newChildren}</div>
        {error && (
          <div className="form-field__error">
            <p className="form-field__error-text">{error}</p>
          </div>
        )}
        {comment && (
          <div className="form-field__comment">
            <p className="form-field__comment-text">{comment}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormField;
